import { ISSUED_LABEL } from "./demo";
import type { IssuedStatus, ReceivedStatus } from "./types";

const RECEIVED_LABEL: Record<ReceivedStatus, string> = {
  recue: "Reçue",
  cabinet: "Chez le cabinet",
  a_voir: "À ouvrir",
};

export function IssuedChip({ status }: { status: IssuedStatus }) {
  return (
    <span className={`fx-einv-chip is-${status}`}>
      <i aria-hidden />
      {ISSUED_LABEL[status]}
    </span>
  );
}

export function ReceivedChip({ status }: { status: ReceivedStatus }) {
  return (
    <span className={`fx-einv-chip is-${status}`}>
      <i aria-hidden />
      {RECEIVED_LABEL[status]}
    </span>
  );
}
